function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { nl } from 'date-fns/locale';
import { List, Map } from "immutable";
import * as React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { mk_widget } from "widgets-for-react";
import { dateOnlyFormat, uniqueMonthFormat } from "../../../../../custom_utils/moment";
import { ExpandItem } from "../../../../components/library/expandItem";
import { Loader } from "../../../../components/loader";
import { getAvailableLocationTimes, postLocationOption } from "./LocationOptionFormApi";
import { allFields, initialState, minimumRentalDate, setFieldOnState, setMeans, setVisited, validateFormData } from "./LocationOptionFormState";
import { fastFields } from './LocationOptionFormValidation';
import { LocationOptionPartsOfDayInput } from "./TimeslotInput/TimeslotInputLayout";
import { initialTimeslotSelection } from "./TimeslotInput/TimeslotInputState";
const moment = require("moment");
const debounce = require('lodash.debounce');
registerLocale('nl', nl);
const asEuros = (price)=>price.toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'EUR'
    });
const FORM_ELEMENT_ID = 'zv-form';
function Expand(props) {
    return mk_widget({
        run: ()=>ExpandItem({
                ...props
            })
    });
}
const MeansCategory = (title, means, meansSelection, updateMeans, toggleCategory)=>Expand({
        key: `expand--${title}`,
        title: title,
        child: /*#__PURE__*/ _jsx(_Fragment, {
            children: means.map((m)=>MeansInput(m, meansSelection.get(m.meansID, 0), updateMeans)).toArray()
        })
    }).run((_)=>toggleCategory(title));
const MeansInput = (means, currentAmount, updateMeans)=>/*#__PURE__*/ _jsxs("div", {
        className: "zv-form__group",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "zv-form__checkbox form__checkbox",
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        means.name,
                        means.price > 0 && /*#__PURE__*/ _jsxs("span", {
                            className: "zv-form__secondary-info text--s",
                            children: [
                                " – ",
                                asEuros(means.price),
                                means.pricePerItem ? ' per stuk' : ''
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "zv-form__amount",
                children: [
                    /*#__PURE__*/ _jsx("label", {
                        className: "zv-form__sublabel",
                        htmlFor: `option-form-item-${means.meansID}-number`,
                        children: "Aantal"
                    }),
                    /*#__PURE__*/ _jsx("input", {
                        className: "zv-form__input form__input",
                        id: `option-form-item-${means.meansID}-number`,
                        name: "Aantal",
                        type: "number",
                        min: 0,
                        max: means.count ? means.count : undefined,
                        value: currentAmount,
                        onChange: (e)=>updateMeans(means.meansID, e.target.valueAsNumber)
                    })
                ]
            })
        ]
    }, `option-form-item-${means.meansID}`);
export class LocationOptionForm extends React.Component {
    componentDidUpdate(prevProps) {
        // Load availabities for current and next month
        this.loadMonthAvailabilities(moment().format(uniqueMonthFormat));
        this.loadMonthAvailabilities(moment().add(1, 'month').format(uniqueMonthFormat));
        // Ensure there is a proper selection for Seatplan once the location loaded
        if (prevProps.location.kind != 'loaded' && this.props.location.kind == 'loaded') {
            const defaultSeatplanId = this.firstSeatplanId(this.props.location);
            this.setField('seatplanId')(defaultSeatplanId);
        }
    }
    async loadMonthAvailabilities(monthLabel) {
        if (this.state.monthlyAvailabilities.has(monthLabel)) return;
        this.setState((s0)=>{
            const monthlyAvailabilities = s0.monthlyAvailabilities.set(monthLabel, Map());
            return {
                ...s0,
                monthlyAvailabilities
            };
        }, async ()=>{
            const month = await getAvailableLocationTimes(moment(monthLabel).toDate(), this.props.locationId);
            this.setState((s1)=>{
                const monthlyAvailabilities = s1.monthlyAvailabilities.set(monthLabel, month);
                return {
                    ...s1,
                    monthlyAvailabilities
                };
            });
        });
    }
    isDatePickable(date) {
        const monthLabel = moment(date).format(uniqueMonthFormat);
        const month = this.state.monthlyAvailabilities.get(monthLabel);
        if (month == undefined) return false;
        const key = moment(date).format(dateOnlyFormat);
        const day = month.get(key);
        if (day == undefined) return false;
        return day.morning || day.afternoon || day.evening;
    }
    toggleCategory(category) {
        const oldCategories = this.state.expandedMeansCategories;
        const categories = oldCategories.has(category) ? oldCategories.delete(category) : oldCategories.add(category);
        this.setState((prev)=>({
                ...prev,
                expandedMeansCategories: categories
            }));
    }
    updateMeans(id, amount) {
        this.setState((prevState)=>({
                ...prevState,
                data: {
                    ...prevState.data,
                    means: setMeans(prevState.data.means)(id, amount)
                }
            }));
    }
    submit() {
        const { location, means } = this.props;
        if (location.kind != 'loaded' || means.kind != 'loaded') return;
        this.setState((prevState)=>({
                ...prevState,
                submitting: true
            }), async ()=>{
            const message = await postLocationOption(location.value, this.state.data, means.value).then((result)=>{
                if (result.kind != 'result') throw result.kind;
                const m = {
                    kind: "success",
                    message: "Formulier is succesvol verstuurd naar De Nieuwe Bibliotheek. Wij nemen zo spoedig mogelijk contact met u op."
                };
                return m;
            }).catch((e)=>{
                console.error('Submitting form failed', e);
                const m = {
                    kind: "error",
                    message: "Er is iets mis gegaan tijdens het versturen van het formulier"
                };
                return m;
            });
            // Ensure the form gets reset if submit was successful
            const success = message.kind == 'success';
            const nextState = success ? initialState : this.state;
            const { visited, expandedMeansCategories, data } = nextState;
            if (success) data.seatplanId = this.firstSeatplanId(location);
            this.setState((prevState)=>({
                    ...prevState,
                    message,
                    data,
                    visited,
                    expandedMeansCategories,
                    submitting: false
                }), ()=>window.scroll({
                    top: window.document.getElementById(FORM_ELEMENT_ID).offsetTop,
                    behavior: 'smooth'
                }));
        });
    }
    availabilityForSelectedDate() {
        const date = moment(this.state.data.date);
        const monthLabel = date.format(uniqueMonthFormat);
        const dateLabel = date.format(dateOnlyFormat);
        return this.state.monthlyAvailabilities.get(monthLabel, Map()).get(dateLabel, initialTimeslotSelection);
    }
    maxParticipants() {
        const { location } = this.props;
        const { seatplanId } = this.state.data;
        return location.kind != 'loaded' ? Number.MAX_VALUE : seatplanId ? location.value.seatplans.find((s)=>s.seatplanID == seatplanId).capacity // Max participants of selected plan
         : List(location.value.seatplans).max((s)=>s.capacity).capacity // or max participants of all plans
        ;
    }
    validate(fields) {
        const maxParticipants = this.maxParticipants();
        validateFormData(this.setState.bind(this), {
            maxParticipants
        })(fields);
    }
    render() {
        const { props: { means, location, hideForm }, state, set, setField, visit } = this;
        const { data, visited, validationMessages, submitting, message } = state;
        const selectedMeans = data.means;
        const formIsNotValid = validationMessages.size > 0;
        const maxParticipants = this.maxParticipants();
        const meansCategories = means.kind != 'loaded' ? /*#__PURE__*/ _jsx(Loader, {}, "loader--means") : List(means.value).groupBy((m)=>m.category.description).filter((_, description)=>!description.includes("online niet zichtbaar")).map((groupedMeans, description)=>MeansCategory(description, groupedMeans.toList(), selectedMeans, (id, amount)=>!submitting && this.updateMeans(id, amount), (category)=>!submitting && this.toggleCategory(category))).toArray();
        const seatplanOptions = location.kind != 'loaded' ? /*#__PURE__*/ _jsx(_Fragment, {}) : List(location.value.seatplans).sortBy((s)=>s.name.toLocaleLowerCase().replace(/[^a-z0-9]/g, '')).map((s)=>/*#__PURE__*/ _jsx("option", {
                value: s.seatplanID,
                children: `${s.name} (max. ${s.capacity})`
            }, s.seatplanID)).toArray();
        const validationClass = (field)=>{
            if (validationMessages.has(field)) return 'input--error';
            if (visited.has(field)) return 'input--valid';
            return 'input--unvalidated';
        };
        if (hideForm) return /*#__PURE__*/ _jsx(_Fragment, {});
        return /*#__PURE__*/ _jsx("div", {
            id: FORM_ELEMENT_ID,
            className: `zv-form container--mg align--center${submitting ? ' zv-form--disabled' : ''}`,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "zv-form__inner",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "zv-form__title title--l container--m",
                        children: "Offerte aanvragen? Vul vrijblijvend het formulier in"
                    }),
                    message && /*#__PURE__*/ _jsx("div", {
                        className: `announcement__inner ${message.kind} text--styled`,
                        role: "alert",
                        children: message.message
                    }),
                    /*#__PURE__*/ _jsxs("form", {
                        onSubmit: (e)=>e.preventDefault(),
                        className: "zv-form__form",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "zv-form__field zv-form__field--2-fifth",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "firstName",
                                        className: "zv-form__label",
                                        children: "Voornaam"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        disabled: submitting,
                                        type: "text",
                                        id: "firstName",
                                        className: `zv-form__input form__input ${validationClass('firstName')}`,
                                        value: data.firstName,
                                        onFocus: visit('firstName'),
                                        onChange: set('firstName')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "zv-form__field zv-form__field--1-fifth",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "infix",
                                        className: "zv-form__label",
                                        children: "Tussenvoegsel"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        disabled: submitting,
                                        type: "text",
                                        id: "infix",
                                        className: `zv-form__input form__input ${validationClass('infix')}`,
                                        value: data.infix,
                                        onFocus: visit('infix'),
                                        onChange: set('infix')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "zv-form__field zv-form__field--2-fifth",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "lastName",
                                        className: "zv-form__label",
                                        children: "Achternaam"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        disabled: submitting,
                                        type: "text",
                                        id: "lastName",
                                        className: `zv-form__input form__input ${validationClass('lastName')}`,
                                        value: data.lastName,
                                        onFocus: visit('lastName'),
                                        onChange: set('lastName')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "zv-form__field zv-form__field--half",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "email",
                                        className: "zv-form__label",
                                        children: "E-mail"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        disabled: submitting,
                                        type: "email",
                                        id: "email",
                                        className: `zv-form__input form__input ${validationClass('email')}`,
                                        value: data.email,
                                        onFocus: visit('email'),
                                        onChange: set('email')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "zv-form__field zv-form__field--half",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "phoneNumber",
                                        className: "zv-form__label",
                                        children: "Telefoonnummer"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        disabled: submitting,
                                        type: "text",
                                        id: "phoneNumber",
                                        className: `zv-form__input form__input ${validationClass('phoneNumber')}`,
                                        value: data.phoneNumber,
                                        onFocus: visit('phoneNumber'),
                                        onChange: set('phoneNumber')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "zv-form__field",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "companyName",
                                        className: "zv-form__label",
                                        children: "Bedrijfsnaam"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        disabled: submitting,
                                        type: "text",
                                        id: "companyName",
                                        className: `zv-form__input form__input ${validationClass('companyName')}`,
                                        value: data.companyName,
                                        onFocus: visit('companyName'),
                                        onChange: set('companyName')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "zv-form__field zv-form__field--half",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "zvf-type",
                                        className: "zv-form__label",
                                        children: "Opstelling"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "form__select",
                                        children: /*#__PURE__*/ _jsx("select", {
                                            disabled: submitting,
                                            onFocus: visit('seatplanId'),
                                            onChange: (e)=>setField('seatplanId')(Number(e.target.value)),
                                            value: data.seatplanId,
                                            id: "zvf-type",
                                            children: seatplanOptions
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "zv-form__field zv-form__field--half",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "participants",
                                        className: "zv-form__label",
                                        children: "Verwachte aantal deelnemers"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        disabled: submitting,
                                        type: "number",
                                        min: 0,
                                        max: maxParticipants,
                                        id: "participants",
                                        className: `zv-form__input form__input ${validationClass('participants')}`,
                                        value: data.participants,
                                        onFocus: visit('participants'),
                                        onChange: set('participants')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "zv-form__field zv-form__field--half",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "orderDate",
                                        className: "zv-form__label",
                                        children: "Gewenste datum"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "form__item--icon right",
                                        children: [
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                id: "orderDate",
                                                locale: "nl",
                                                dateFormat: "EEEE, dd MMMM yyyy",
                                                minDate: minimumRentalDate,
                                                selected: data.date,
                                                onFocus: visit('date'),
                                                onChange: (newDate)=>{
                                                    setField('date')(newDate, ()=>{
                                                        // Selecting a date, then timeslots, then a new date may lead to
                                                        // a previously selected time slot to become unavailable on the new date.
                                                        // The following will reset the timeslot selection when this happens.
                                                        const available = this.availabilityForSelectedDate();
                                                        const selected = this.state.data.timeslots;
                                                        if (selected.morning && !available.morning || selected.afternoon && !available.afternoon || selected.evening && !available.evening) setField('timeslots')(initialTimeslotSelection, ()=>this.validate(this.state.visited));
                                                    });
                                                },
                                                filterDate: (date)=>this.isDatePickable(date),
                                                onMonthChange: (date)=>{
                                                    this.loadMonthAvailabilities(moment(date).format(uniqueMonthFormat));
                                                    this.loadMonthAvailabilities(moment(date).add(1, 'month').format(uniqueMonthFormat));
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx("svg", {
                                                className: "form__icon",
                                                width: "20px",
                                                height: "22px",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ _jsx("use", {
                                                    xlinkHref: "#icon--calendar-dnb"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "zv-form__field zv-form__field--half",
                                children: /*#__PURE__*/ _jsx(LocationOptionPartsOfDayInput, {
                                    date: data.date,
                                    selection: data.timeslots,
                                    availability: this.availabilityForSelectedDate(),
                                    updateSelection: (newSelection)=>setField('timeslots')(newSelection, ()=>{
                                            this.visit('timeslots');
                                            this.validate(visited.add('timeslots'));
                                        })
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "zv-form__field zv-form__field--extra",
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "zv-form__subtitle title--xs",
                                        children: "Aanvullende zaken"
                                    }, "means__title"),
                                    /*#__PURE__*/ _jsx("ul", {
                                        className: "block__list expand__list",
                                        children: meansCategories
                                    })
                                ]
                            }, "form__means"),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "zv-form__field",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "notes",
                                        className: "zv-form__label",
                                        children: "Opmerkingen, bijv. catering"
                                    }),
                                    /*#__PURE__*/ _jsx("textarea", {
                                        disabled: submitting,
                                        name: "notes",
                                        id: "notes",
                                        className: "zv-form__input form__textarea",
                                        value: data.note,
                                        onChange: (e)=>setField('note')(e.target.value)
                                    })
                                ]
                            }),
                            formIsNotValid && /*#__PURE__*/ _jsx("div", {
                                className: "announcement__inner error text--styled",
                                role: "alert",
                                children: /*#__PURE__*/ _jsx("ul", {
                                    children: validationMessages.map((value, key)=>/*#__PURE__*/ _jsx("li", {
                                            children: value
                                        }, key)).toArray()
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "zv-form__submit",
                                children: /*#__PURE__*/ _jsx("button", {
                                    disabled: formIsNotValid || submitting,
                                    type: "submit",
                                    onMouseOver: ()=>this.validate(allFields),
                                    onClick: ()=>this.submit(),
                                    className: "button button--primary button--arrow",
                                    children: submitting ? "Aanvraag wordt verzonden" : "Aanvraag verzenden"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props), _define_property(this, "setField", setFieldOnState(this.setState.bind(this))), _define_property(this, "set", (field)=>(e)=>{
                this.setField(field)(e.target.value, ()=>{
                    const fields = this.state.visited.add(field);
                    fastFields.has(field) ? this.validate(fields) : this.validateVisitedAfterDelay(fields);
                });
            }), _define_property(this, "setVisit", setVisited(this.setState.bind(this))), _define_property(this, "visit", (field)=>()=>setVisited(this.setState.bind(this))(field)), _define_property(this, "firstSeatplanId", (location)=>List(location.value.seatplans).sortBy((s)=>s.name.toLocaleLowerCase().replace(/[^a-z0-9]/g, '')).first().seatplanID), _define_property(this, "validateVisitedAfterDelay", debounce((fields)=>this.validate(fields), 1000));
        this.state = {
            ...initialState
        };
    }
}
{}